import React from 'react';
import { View } from 'react-native';

import { Button } from '@/components/ButtonComponent';
import { SizedBox } from '@/components/SizedBox';
import { Text } from '@/components/TextComponent';
import { ds } from '@/components/lib/design.system';
import { common } from '@/styles/styles';

type EntriesEmptyListProps = {
    label: string;
    navigateHome: () => void;
};

const EntriesEmptyList = ({ label, navigateHome }: EntriesEmptyListProps) => {
    return (
        <View style={[common.full, common.alignCenter]}>
            <SizedBox value={180} />
            <Text variant="titleLarge">No {label} entries</Text>
            <SizedBox value={4} />
            <Text variant="bodyMedium" color={ds.colorToken.text.secondary} textAlign={'center'}>
                When you have {label} entries, they'll appear here.
            </Text>
            <SizedBox value={24} />
            <Button label="Browse players" hierarchy={'subtle'} shape={'pill'} onPress={navigateHome} />
        </View>
    );
};

export default EntriesEmptyList;
